var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Виджеты")]),_c('p',[_vm._v(" В разделе "),_c('strong',[_vm._v("Виджеты")]),_vm._v(" отображены отчеты, которые относятся к вашему бизнесу, собираются из ваших информационных источников (см. раздел "),_c('strong',[_vm._v("Источники")]),_vm._v(" ), а также показывают ключевые показатели, необходимую вам аналитику и работу с клиентами. ")])])
}]

export { render, staticRenderFns }